<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="作品消息" name="workMsg">
        <my-work-message></my-work-message>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import MyWorkMessage from './myWorkMessage'
export default {
  name: 'messageTab',
  components: {MyWorkMessage},
  data () {
    return {
      activeName: 'workMsg'
    }
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab, event);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/my/messageTab.vue